export default "__VITE_ASSET__7EM6zrlH__"